import * as React from "react";
import { SpecialtyGroupExceptionReviewStatus } from "@app/exceptions/enums";
import { Badge, BadgeClassNames } from "@app/shared/Badge";

interface BadgeProps {
  status: SpecialtyGroupExceptionReviewStatus;
  children: React.ReactNode;
}

const ExceptionsBadge: React.FC<BadgeProps> = ({
  status,
  children,
}) => {
  if (status === SpecialtyGroupExceptionReviewStatus.None) {
    return null;
  }

  const getBadgeClass = (status: SpecialtyGroupExceptionReviewStatus): BadgeClassNames => {
    switch (status) {
      case SpecialtyGroupExceptionReviewStatus.ReadyForReview:
        return "badge--warning";
      case SpecialtyGroupExceptionReviewStatus.ReadyForSubmission:
        return "badge--success";
      case SpecialtyGroupExceptionReviewStatus.NotReady:
        return "badge--danger";
    }
  };

  return (
    <Badge
      badgeType={getBadgeClass(status)}
    >
      {children}
    </Badge>
  );
};

export default ExceptionsBadge;
